// src/pages/district/SubmittedESMP.jsx
import { useState, useEffect } from "react";
import DistrictSidebar from "../../components/DistrictSidebar";
import api from "../../services/api";
import { downloadEsmpFile } from "../../utils/fileDownload";

export default function SubmittedESMP() {
  const [search, setSearch] = useState("");
  const [submittedEsmp, setSubmittedEsmp] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMyEsmps = async () => {
      try {
        setLoading(true);
        const res = await api.get("/district/my-esmps");
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        setSubmittedEsmp(data);
      } catch (err) {
        console.error("Failed to load submitted ESMPs:", err);
        setSubmittedEsmp([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMyEsmps();
  }, []);

  const filtered = submittedEsmp.filter(
    (e) =>
      (e.project_name || "").toLowerCase().includes(search.toLowerCase()) ||
      (e.district || "").toLowerCase().includes(search.toLowerCase()) ||
      (e.esmp_id || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex h-screen overflow-hidden bg-gray-100">
      <DistrictSidebar />

      <main className="flex-1 overflow-y-auto p-6 space-y-6">
        {/* HEADER */}
        <div className="flex justify-between items-center bg-gradient-to-r from-green-700 to-green-500 text-white p-5 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold">Submitted ESMPs</h2>
          <input
            type="text"
            placeholder="Search ESMP..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-3 py-2 rounded text-black border focus:ring-2 focus:ring-green-600 outline-none"
          />
        </div>

        {/* ESMP Table */}
        <div className="bg-white p-6 rounded-xl shadow overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2 text-left">ESMP ID</th>
                <th className="border p-2 text-left">District</th>
                <th className="border p-2 text-left">Project Name</th>
                <th className="border p-2 text-left">Status</th>
                <th className="border p-2 text-left">Files</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td className="border p-2 text-center" colSpan={5}>
                    Loading submitted ESMPs...
                  </td>
                </tr>
              ) : filtered.length > 0 ? (
                filtered.map((item, idx) => (
                  <tr key={idx}>
                    <td className="border p-2">{item.esmp_id}</td>
                    <td className="border p-2">{item.district}</td>
                    <td className="border p-2">{item.project_name}</td>
                    <td className="border p-2">{item.status}</td>
                    <td className="border p-2">
                      {item.file_path ? (
                        <button
                          type="button"
                          onClick={() => downloadEsmpFile(item)}
                          className="text-blue-600 hover:underline"
                        >
                          {item.file_name || "Download document"}
                        </button>
                      ) : (
                        <span className="text-gray-500">No file</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border p-2 text-center" colSpan={5}>
                    No ESMPs found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}

